export const convertUnderscoresToSpaces = (str: string) =>
  str ? str.replace(/_/g, " ") : str;
